export enum ErrorType {
  PageNotFound = 'PAGE_NOT_FOUND',
  PageTypeInvalid = 'PAGE_TYPE_INVALID',
  PageCancelled = 'PAGE_CANCELLED',
}

export enum AlertTypes {
  warning = 'warning',
  error = 'error',
  success = 'success',
  info = 'info',
}
export const ALERT_TYPE_PARAMETER = 'alertType';
export const ALERT_MESSAGE_PARAMETER = 'alertMessage';
export const DONATION_ERROR = 'donationError';
